
import { Header } from "@/components/Header";
import { OrganizationInvite } from "@/components/organizations/OrganizationInvite";
import { OrganizationMemberList } from "@/components/organizations/OrganizationMemberList";
import { UserList } from "@/components/users/UserList";
import { useAuth } from "@/contexts/AuthContext";
import { useOrganization } from "@/contexts/OrganizationContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const OrganizationMembers = () => {
  const { session, isLoading } = useAuth();
  const { currentOrganization } = useOrganization();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (!isLoading && !session) {
      navigate("/auth");
    }
  }, [session, isLoading, navigate]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="container mx-auto py-6">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-3xl font-bold">Team Management</h1>
            <p className="text-muted-foreground">
              Manage your organization's team and system users
            </p>
          </div>
          {currentOrganization?.role === 'admin' && <OrganizationInvite />}
        </div>

        <Tabs defaultValue="members" className="space-y-4">
          <TabsList>
            <TabsTrigger value="members">Team Members</TabsTrigger>
            {currentOrganization?.role === 'admin' && (
              <TabsTrigger value="all-users">All System Users</TabsTrigger>
            )}
          </TabsList>

          <TabsContent value="members">
            <div className="bg-white rounded-lg shadow-sm">
              <OrganizationMemberList />
            </div>
          </TabsContent>

          {currentOrganization?.role === 'admin' && (
            <TabsContent value="all-users">
              <div className="bg-white rounded-lg shadow-sm">
                <p className="p-4 text-sm text-muted-foreground border-b">
                  This list shows all users in the system, including those not in your current organization.
                  Administrators can view and manage all system users.
                </p>
                <UserList />
              </div>
            </TabsContent>
          )}
        </Tabs>
      </div>
    </div>
  );
};

export default OrganizationMembers;
